import { FunctionalComponent } from 'preact'
import { Timezone } from './types'

export interface DropdownTextProps {
  timezones: Timezone[]
  selected?: Timezone
  label?: string
}

export const DropdownText: FunctionalComponent<DropdownTextProps> = ({ timezones, selected, label }) => {
  if (timezones.length === 0) {
    return <div className='timezone-selector-placeholder'>Loading timezones...</div>
  }
  if (selected) {
    return (
      <span className='selected'>
        {label ? <div className='timezone-selected-label'>{label}</div> : null}
        <div className='truncated'>{selected.title}</div>
      </span>
    )
  }
  return <div className='timezone-selector-placeholder'>Choose a timezone</div>
}
